import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

type Props = {
  suffix: string;
  size?: string;
};

const useStyles = makeStyles(() => ({
  trulabel: {
    display: 'inline',
    fontFamily: 'Soleil',
    fontWeight: 600,
    marginRight: '10px',
  },
  truprefix: {
    color: '#2274A5',
  },
}));

export const TruLabel = ({ suffix, size }: Props) => {
  const variant = size === 'lg' ? 'h4' : 'h5';
  const classes = useStyles();

  return (
    <Typography variant={variant} className={classes.trulabel}>
      <span className={classes.truprefix}>tru</span>
      {suffix}
    </Typography>
  );
};
